import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import {
  addContractorCode,
  editContractorCode,
  generateContractorCode,
  getContractorCodes,
  removeContractorCode,
} from "@/requests/administration/contractors/contractorCodesAdministration";
import { ContractorCode } from "@/models/api/administration/contractors/ContractorCode";
import { AddEditContractorCode } from "@/models/api/administration/contractors/AddEditContractorCode";

export interface AdministrationContractorCodesInterface {
  isAddDialog: boolean;
  isEditDialog: boolean;
  contractorCodeId: number | null;
  editContractorCodeModel: AddEditContractorCode;
  contractorCodes: Array<ContractorCode>;
  generatedContractorCode: string;
}

export const AdministrationContractorCodesState: AdministrationContractorCodesInterface = {
  isAddDialog: false,
  isEditDialog: false,
  contractorCodeId: null,
  editContractorCodeModel: new AddEditContractorCode(),
  contractorCodes: [],
  generatedContractorCode: "",
};

const AdministrationContractorCodesStateModule = defineModule({
  state: AdministrationContractorCodesState as AdministrationContractorCodesInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setContractorCodes(state, param: Array<ContractorCode>) {
      state.contractorCodes = param;
    },
    setIsAddDialog(state, param: boolean) {
      state.isAddDialog = param;
    },
    setIsEditDialog(state, param: boolean) {
      state.isEditDialog = param;
    },
    setGeneratedContractorCode(state, param: number) {
      state.generatedContractorCode = param.toString();
    },
    setContractorCodeId(state, param: number | null) {
      state.contractorCodeId = param;
    },
    setEditContractorCodeModel(state, param: AddEditContractorCode) {
      state.editContractorCodeModel = param;
    },
  },
  actions: {
    async downloadContractorCodes(context) {
      const { rootState, commit } = _moduleActionContext(context);
      if (rootState.administration.contractors.list.selectedContractorId !== null) {
        const result = await getContractorCodes(rootState.administration.contractors.list.selectedContractorId);
        commit.setContractorCodes(result);
      }
    },
    async generateContractorCode(context) {
      const { rootState, commit } = _moduleActionContext(context);
      if (rootState.administration.contractors.list.selectedContractorId !== null) {
        const result = await generateContractorCode();
        commit.setGeneratedContractorCode(result);
      }
    },
    async addContractorCode(context, newContractorCode: AddEditContractorCode) {
      const { rootState, dispatch } = _moduleActionContext(context);
      if (rootState.administration.contractors.list.selectedContractorId !== null) {
        await addContractorCode(rootState.administration.contractors.list.selectedContractorId, newContractorCode);
        dispatch.downloadContractorCodes();
      }
    },
    async editContractorCode(context, param: AddEditContractorCode) {
      const { dispatch, state } = _moduleActionContext(context);
      await editContractorCode(state.contractorCodeId as number, param);
      dispatch.downloadContractorCodes();
    },
    async removeContractorCode(context, contractorCodeId: number) {
      const { dispatch } = _moduleActionContext(context);
      await removeContractorCode(contractorCodeId);
      dispatch.downloadContractorCodes();
    },
  },
});

export default AdministrationContractorCodesStateModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, AdministrationContractorCodesStateModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, AdministrationContractorCodesStateModule);
